<!-- Notification group template -->
<ng-template #notificationGroup
             let-group>
    <h3 class="notif-list__group-date">
        {{group.date}}
    </h3>
    <ul class="notif-list__group-list">
        @for (notification of group.notifications; track notification.id) {
            <li class="notif-list__group-item">
                <button class="notif-list__notification-button"
                        [class.notif-list__notification-button--unread]="!notification.read"
                        [class.notif-list__notification-button--assignment]="notification.type === 'activity'"
                        (click)="onSelect(notification)">
                    <mat-icon class="notif-list__notification-primary-icon"
                            [svgIcon]="notification.type === 'activity' ? 'notif-list__assignment' : 'notif-list__notification'">
                    </mat-icon>
                    <span class="notif-list__notification-type">
                        @if (notification.type === 'activity') {
                            {{'notification.new_assignment' | translate}}
                        } @else {
                            {{'notification.new' | translate}}
                        }
                    </span>
                    <span class="notif-list__notification-label">
                        {{notification.label}}
                    </span>
                    <mat-icon class="notif-list__notification-secondary-icon"
                            svgIcon="notif-list__open">
                    </mat-icon>
                </button>
            </li>
        }
    </ul>
</ng-template>

@if (unreadNotificationsGroup || readNotificationsGroup) {
    <!-- Unread/Unseen notifications -->
    @if (unreadNotificationsGroup) {
        <section class="notif-list__section">
            <h2 class="notif-list__section-title">
                {{unreadNotificationsGroup.status | translate}}
            </h2>
            @for (group of unreadNotificationsGroup.dateGroups; track group.date) {
                <ng-container *ngTemplateOutlet="notificationGroup; context: {$implicit: group}">
                </ng-container>
            }
            @if (hasReadNotifications && !areReadNotificationsDisplayed) {
                <button class="notif-list__display-read-button"
                        [attr.aria-expanded]="areReadNotificationsDisplayed"
                        [attr.aria-controls]="'notif-list-read-section'"
                        (click)="displayReadNotifications()">
                    <span class="notif-list__display-read-label">
                        {{ 'notification.show_already_seen' | translate }}
                    </span>
                </button>
            }
        </section>
    }
    <!-- Notifications already read/seen -->
    @if (readNotificationsGroup && areReadNotificationsDisplayed) {
        <section class="notif-list__section"
                 id="notif-list-read-section">
            <h2 class="notif-list__section-title">
                {{readNotificationsGroup.status | translate}}
            </h2>
            @for (group of getLimitedReadNotifications(); track group.date) {
                <ng-container *ngTemplateOutlet="notificationGroup; context: {$implicit: group}">
                </ng-container>
            }
            @if (hasMoreReadNotifications()) {
                <button class="notif-list__display-more-button"
                        [attr.aria-controls]="'notif-list-read-section'"
                        (click)="displayMoreReadNotifications()">
                    <span class="notif-list__display-more-label">
                        {{ 'notification.show_older' | translate }}
                    </span>
                </button>
            }
        </section>
    }
} @else {
    <!-- No notification message -->
    <p class="notif-list__no-notification-message">
        {{'notification.no_notification_yet' | translate}}
    </p>
}
